
class LocalStorageService {
  setAuthorization (token) {
    localStorage.authorization = token
  }

  getAuthorization () {
    return localStorage.authorization
  }

  deleteAuthorization () {
    localStorage.removeItem('authorization')
  }

  setUsername (username) {
    localStorage.username = username
  }

  getUsername () {
    return localStorage.username
  }

  deleteUsername () {
    localStorage.removeItem('username')
  }

  setLoginMessage (message) {
    localStorage.loginMessage = message
  }

  getLoginMessage () {
    return localStorage.loginMessage
  }

  deleteLoginMessage () {
    localStorage.removeItem('loginMessage')
  }

  setUserDetails (userDetails) {
    localStorage.userDetails = JSON.stringify(userDetails)
  }

  getUserDetails () {
    try {
      return JSON.parse(localStorage.userDetails)
    } catch (e) {
      return {}
    }
  }

  deleteUserDetails () {
    localStorage.removeItem('userDetails')
  }

  getUserClientPrefix () {
    return this.getUserDetails().clientPrefix
  }

  setAccessUrl (url) {
    localStorage.accessUrl = url
  }

  getAccessUrl () {
    return localStorage.accessUrl
  }

  deleteAccessUrl () {
    localStorage.removeItem('accessUrl')
  }

  setClientName (name) {
    localStorage.clientName = name
  }

  getClientName () {
    return localStorage.clientName
  }

  isPlatform () {
    const PLATFORM_URL_RE = /^https:\/\/(www\.)?seniorconnect.com.br:9010/
    return !!localStorage.accessUrl && PLATFORM_URL_RE.test(localStorage.accessUrl)
  }

  setCurrentVersion (version) {
    localStorage.currentVersion = version
  }

  getCurrentVersion () {
    return localStorage.currentVersion
  }

  setClientPrefix (clientPrefix) {
    localStorage.clientPrefix = clientPrefix
  }

  getClientPrefix () {
    return localStorage.clientPrefix
  }
}

export default new LocalStorageService()
